import { GET_DOWNLOADS } from '../actions/action.types';

export default (state = 0, action) => {
  switch (action.type) {
    case GET_DOWNLOADS:
      return action.payload || 0;
    default:
      return state;
  }
};
